import { Controller } from '@hotwired/stimulus';

// Toggles the expanded detail timeline of a single receipt.
export default class extends Controller {
  static targets = ['detail'];

  toggle(event) {
    event.preventDefault();
    if (!this.hasDetailTarget) return;
    const isHidden = this.detailTarget.hidden;
    this.detailTarget.hidden = !isHidden;
    this.element.classList.toggle('receipt-expanded', isHidden);
  }
}
